var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPepwiselogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 826.1 188.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #003771;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2,58.9h63.4c21.8,0,29.8,9.8,29.8,27.1s-7.8,26.5-29.6,26.5h-32.9v24.2h-30.7V58.9h0ZM224.9,93.5h19.8c7.7,0,10.7-2.4,10.7-8.1s-2.9-8.3-10.7-8.3h-19.8v16.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.2,118.8c-2.1,6.2-6.6,11.3-13.6,14.8s-16.3,5.4-28.9,5.4c-28.6,0-45-10.4-45-32.2s15.7-32.1,42.5-32.1,45.7,8.8,45.3,38.6h-59.9c0,4.2,4.5,10.8,16.4,10.8s11.2-1.5,14.2-5.2h29ZM353.1,99.5c-.5-6.4-6.8-10.4-16.1-10.4s-14.9,2.9-16.3,10.4h32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.8,77.1h26.4v7.1h.2c4.9-5.7,12.4-8.7,24.5-8.7,17.6,0,33.9,9.7,33.9,31.8s-16.2,31.8-33.9,31.8-19-2.7-23.6-8.4h-.2v27.3h-27.2v-80.9h0ZM433.1,120.7c9.8,0,14.8-5.9,14.8-13.5s-4.4-13.5-14.9-13.5-14.9,5-14.9,13.5,4.5,13.5,15,13.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.9,58.9h29.7l10,47.5h.2l11.4-47.5h24.5l11.3,47.5h.2l10-47.5h29.7l-22.8,77.8h-30.2l-10.6-43.1h-.2l-10.7,43.1h-30.2l-22.6-77.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612.5,56.2h27.2v15h-27.2v-15ZM612.5,77.1h27.2v59.6h-27.2v-59.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.8,113c-15.8-1.6-20.4-7.9-20.4-18.3s13.1-20,39.6-20,38.9,3.4,39.4,20.3h-30.7c0-1.5-.5-2.8-2.1-3.7-1.5-.9-4-1.5-8.1-1.5-8.2,0-9.7,1.8-9.7,4.1s1.4,3.2,7.3,3.7l25.9,2.3c14.7,1.3,20.3,7.8,20.3,18,0,15.4-13.3,21.2-42,21.2s-40.6-5.9-41.5-20.9h32c.3,2.4,1.5,3.9,3.4,4.8,2,.9,4.7,1.1,7.7,1.1,7,0,9-1.8,9-4.6s-.9-3.4-3.7-3.7l-26.6-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M825.8,118.8c-2.1,6.2-6.6,11.3-13.6,14.8s-16.3,5.4-28.9,5.4c-28.6,0-45-10.4-45-32.2s15.7-32.1,42.5-32.1,45.7,8.8,45.3,38.6h-59.9c0,4.2,4.5,10.8,16.4,10.8s11.2-1.5,14.2-5.2h29ZM798.7,99.5c-.5-6.4-6.8-10.4-16.1-10.4s-14.9,2.9-16.3,10.4h32.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Drop",
    className: "st0",
    d: "M134.1,93c1-13.9-1.4-29.3-12.8-38.6-5.4-3.8-9.1-10.1-8.6-16.9,1-14.5,16.1-21.9,28.1-14.9,2.8,1.6,5.1,3.9,7.1,6.5,15.5,19.9,6.4,50.6-12.6,64.5-.5.4-1.2,0-1.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Smile",
    className: "st0",
    d: "M147.1,148.9c1.4-2.5-1.6-5-4-3.4-21.8,13.8-48.8,19.4-76.1,13.7-25.2-5.2-46.3-19.2-60.8-38.1-1.8-2.3-5.5-1-5,1.8,6.3,38.3,40.2,66.9,80,65.7,28.4-.9,52.8-16.7,66-39.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leaf",
    className: "st0",
    d: "M91.3,128.9c-3.9-1.3-7.1-3.5-9.8-6.2-.3-.3-.4-.4-.5-.5-.4-.3-.9,0-1.1.4,0,0,0,.3,0,.6v27.7c1.9.1,3.9.2,5.9.2,18.8,0,36.2-6,50.3-16.3,9.2-6.7,16.9-15.6,22-26.2.3-.6.1-1.4-.5-1.7-6-3.9-13.1-6.2-20.8-6.2s-2.8,0-4.1.2c-4,18.4-15.7,29.5-31.6,29.5s-6.9-.5-9.9-1.5h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grain"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,108.6c-7.7,0-11.8-9.2-11.8-20.5s4.1-20.5,11.8-20.5,11.8,9.2,11.8,20.5-4.1,20.5-11.8,20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,58c-.3.7-1.1.9-1.7.6-10.8-4.8-18.4-15.6-18.4-28.2s1.1-9.3,3-13.3c.3-.6,1.1-.9,1.7-.6,10.8,4.8,18.4,15.6,18.4,28.2s-1.1,9.3-3,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,57.5c4.8-6.8,11.8-10.6,21.4-10.6s2.7,0,4.1.3c.2-6.8-.4-13.4-1.5-19.8-.7-3.8-1.6-7.5-2.7-11.1-1.6-5.4-3.7-10.7-6.2-15.6-.3-.6-1-.9-1.6-.7C60.5,9.4,35.8,37.6,31.9,72.3c-7-5-15.1-8.8-24.1-10.7-2.1-.5-4.2-.8-6.3-1-.8,0-1.5.6-1.5,1.4,0,1.1,0,2.2,0,3.3,0,32.8,18.4,61.3,45.5,75.8V49.6c0-.4.3-.7.7-.7h22c5.5,0,10,3.8,11.4,8.7h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepwiselogo1);
export default __webpack_public_path__ + "static/media/Pepwise logo1.1a479d5b57cff91d9ea101aa2272ae6e.svg";
export { ForwardRef as ReactComponent };